export enum EnumCommunicationEmojis {
  None = 'none',
  Moderate = 'moderate',
  Frequent = 'frequent'
}

export enum EnumCommunicationResponseStyle {
  Concise = 'concise',
  Balanced = 'balanced',
  Explanatory = 'explanatory'
}

export enum EnumCommunicationPersonality {
  Professional = 'professional',
  Friendly = 'friendly',
  Casual = 'casual',
  Custom = 'custom'
}
